<template>
  <div class="row">
    <div class="col-md-12 p-t-20">
      <h5 class="h5">
        <i class="fe fe-activity"></i> MDA Sector Enrollment Data
      </h5>
    </div>
    <div class="col-md-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div>
            <highcharts :options="chartOptions"></highcharts>
            <br />
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              @input="getDashboardLGA(currentPage ? currentPage : 1)"
            ></b-pagination>

            <p class="mt-3">Current Page: {{ currentPage }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  data() {
    return {
      agency: agency,
      title: "",
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: "",
      seriesColor: "#6fcd98",
      colorInputIsSupported: null,
      chartOptions: {},
      perPage: 300,
      currentPage: 1,
      rows: "1",
    };
  },
  mounted() {
    this.getDashboardLGA();
  },
  methods: {
    getDashboardLGA(currentPage) {
      this.axios
        .get(`/api/v1/auth/dashboardmda/${agency.id}?page=` + currentPage)
        .then((response) => {
          let data = response.data.chartData;
          this.rows = response.data.meta.total;

          this.chartOptions = {
            chart: {
              type: "column",
            },
            title: {
              text: "Ministries Departments and Parastatals",
            },
            subtitle: {
              text: "Enrollees Analysis for State Contributory Health Care Scheme",
            },
            accessibility: {
              announceNewData: {
                enabled: true,
              },
            },
            xAxis: {
              type: "category",
            },
            yAxis: {
              title: {
                text: "NUMBER OF STATE CIVIL SERVANT ENROLLED",
              },

              // STATE CIVIL HEALTH CARE PLAN
              // NUMBER OF STATE CIVIL SERVANT ENROLLED
              // FACILTY DISTRIBUTION
            },
            legend: {
              enabled: false,
            },
            plotOptions: {
              series: {
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                  // format: '{point.y:.1f}'
                },
              },
            },

            tooltip: {
              headerFormat:
                '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
            },

            series: data[0].mda,
          };

          // console.log(series);

          // this.chartOptions.xAxis.categories = categories;
          // this.chartOptions.yAxis.series = series;
          // this.chartOptions = {
          //   xAxis.categories: response.
          // }
        });
    },
  },
};
</script>

<style></style>
